(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-bestek-catalog]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      const resize = () => {
        const wrapper = root.closest('.header-categories-wrapper');
        const pane = root.closest('.categories-inner--submenu');
        if (wrapper && pane && !pane.classList.contains('hidden')) {
          wrapper.style.setProperty('--category-height', `${Math.max(320, pane.getBoundingClientRect().height)}px`);
        }
      };
      function select(tab) {
        tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        requestAnimationFrame(resize);
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', e => { e.stopPropagation(); select(tab); });
        tab.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) select(tab); });
        tab.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowDown') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp') next = (i + tabs.length - 1) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
      root.querySelectorAll('[data-bestek-track]').forEach(track => {
        const warmSecond = card => {
          const image = card.querySelector('[data-bestek-second-src]');
          if (!image || image.hasAttribute('src')) return;
          image.addEventListener('load', () => { if (image.naturalWidth) card.classList.add('second-ready'); }, { once: true });
          image.src = image.dataset.bestekSecondSrc;
        };
        const imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) { warmSecond(entry.target); imageObserver.unobserve(entry.target); } });
        }, { root: null, rootMargin: '80px', threshold: 0.01 }) : null;
        track.querySelectorAll('.bestek-menu-product').forEach(card => {
          imageObserver?.observe(card);
          card.addEventListener('pointerenter', () => warmSecond(card), { once: true });
          card.addEventListener('focusin', () => warmSecond(card), { once: true });
        });
        let startX = 0, startScroll = 0, pointer = null, moved = false;
        track.addEventListener('pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          startX = e.clientX; startScroll = track.scrollLeft; pointer = e.pointerId; moved = false;
        });
        track.addEventListener('pointermove', e => {
          if (pointer !== e.pointerId) return;
          const distance = e.clientX - startX;
          if (Math.abs(distance) > 5 && !moved) {
            moved = true; track.setPointerCapture(pointer); track.classList.add('is-dragging');
          }
          if (moved) { e.preventDefault(); track.scrollLeft = startScroll - distance; }
        });
        const finish = e => {
          if (pointer !== e.pointerId) return;
          if (track.hasPointerCapture(pointer)) track.releasePointerCapture(pointer);
          pointer = null; track.classList.remove('is-dragging');
        };
        track.addEventListener('pointerup', finish);
        track.addEventListener('pointercancel', finish);
        track.addEventListener('pointerleave', e => { if (!moved) finish(e); });
        track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        track.addEventListener('keydown', e => {
          if (e.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          e.preventDefault();
          const offset = e.key === 'ArrowRight' ? track.clientWidth : -track.clientWidth;
          const left = e.key === 'Home' ? 0 : e.key === 'End' ? track.scrollWidth : track.scrollLeft + offset;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      });
      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(root);
      const outerLink = root.closest('.bestek-catalog-root')?.querySelector(':scope > a');
      outerLink?.addEventListener('focus', () => {
        const item = outerLink.closest('.bestek-catalog-root');
        const wrapper = item.closest('.header-categories-wrapper');
        wrapper.querySelectorAll('.categories-inner--submenu').forEach(p => p.classList.toggle('hidden', p !== root.closest('.categories-inner--submenu')));
        resize();
      });
    });
    scope.querySelectorAll('.bestek-products-nav > details').forEach(details => {
      if (details.dataset.bestekReady) return;
      details.dataset.bestekReady = 'true';
      const summary = details.querySelector('summary');
      let clickedOpen = false;
      const setOpen = open => {
        details.open = open; details.classList.toggle('open', open);
        const active = document.querySelector('.header-nav-blocks details[open]');
        document.body.classList.toggle('megamenu-open', Boolean(active));
        document.body.classList.toggle('overflow-hidden', Boolean(active));
      };
      summary.addEventListener('click', e => {
        e.preventDefault();
        const open = e.detail === 0 ? !details.open : !clickedOpen;
        clickedOpen = open; setOpen(open);
      });
      details.addEventListener('mouseleave', () => { clickedOpen = false; });
      summary.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(true); details.querySelector('.bestek-products-dropdown a')?.focus(); }
      });
      details.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); setOpen(false); summary.focus(); } });
      details.addEventListener('focusout', e => { if (!details.contains(e.relatedTarget)) setOpen(false); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
